import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { Account, Writer, Customer } from '../../../types'
import { postContexts } from 'src/logic/post-states'
import { ConfirmBlockModalQueries, Post } from './confirm-block-modal.queries'

@Component({
  selector: `confirm-block-modal`,
  template: `
    <modal (outsideClick)="triggerConfirmation(false)">
      <h5>Verblio Notice: These posts will be declined:</h5>
      <div *ngIf="postsLoading" class="loader">loading...</div>
      <div *ngIf="!postsLoading && totalCount === 0">There are no queued posts by {{writer.shortDisplayName}} that will be declined.</div>
      <table *ngIf="!postsLoading && totalCount > 0" class="table">
        <tr>
          <th>Post Title</th>
          <th *ngIf="context === 'account' && agency()">Client</th>
        </tr>
        <tr *ngFor="let post of posts; let i = index;">
          <td>{{i+1}}. {{post.title}}</td>
          <td *ngIf="context === 'account' && agency()">{{ post.customer.businessName }}</td>
        </tr>
      </table>
      <hr class="brand-hr"/>
      <p><strong>Are you sure you want to block this writer?</strong></p>
      <button (click)="triggerConfirmation(true)" class="btn btn-danger float-right">{{posts.length > 0 ? "Block writer and decline these posts" : "Block writer"}}</button>
      <button type="button" class="btn btn-default float-right" style="margin-right: 10px;" (click)="triggerConfirmation(false)">Cancel</button>
      <div style="clear: both;"></div>
    </modal>
  `
})
export class ConfirmBlockModal implements OnInit {
  @Input() account: Account;
  @Input() writer: Writer;
  @Input() customer: Customer;
  @Input() context: string;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  posts: Post[] = [];
  postsLoading: boolean = false;
  totalCount: number = 0

  constructor(
    private queries: ConfirmBlockModalQueries
  ) {}

  ngOnInit(): void {
    this.postsLoading = true
    if (this.context === 'customer') {
      this.queries.customerPostsQuery({
        customerId: this.customer.id,
        writerId: this.writer.id,
        states: postContexts.queued
      }).subscribe(({data, loading, stale}) => {
        this.postsLoading = loading && stale
        if (data) {
          this.totalCount = data.customer.posts.totalCount
          this.posts = data.customer.posts.entries
        }
      })
    } else if (this.context === 'account') {
      this.queries.accountPostsQuery({
        writerId: this.writer.id,
        states: postContexts.queued
      }).subscribe(({data, loading, stale}) => {
        this.postsLoading = loading && stale
        if (data) {
          this.totalCount = data.account.posts.totalCount
          this.posts = data.account.posts.entries
        }
      })
    }
  }

  triggerConfirmation(confirmed: boolean): void {
    this.onClose.emit(confirmed)
  }

  agency(): boolean {
    return this.account && this.account.customersCount > 1 || this.account.agency
  }
}
